import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Modal from "../../../component/Modal";
import Paging from "../../../component/Paging";
import request from "../../../../utils/Request.utils";
import { formatYmd } from "../../../../utils/Common.utils";

const LIST_PAGE_SIZE = 10;

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return formatYmd(date);
};

const SettingSubAdmin = () => {
  const navigate = useNavigate();
  const [subAdmins, setSubAdmins] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCnt, setTotalCnt] = useState(0);
  const [currPage, setCurrPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const fetchSubAdmins = useCallback(() => {
    // 페이지를 옮기거나 다시 불러올 때는 표를 숨기지 않는다 — 숨겼다 다시 그리면 표·페이지 번호가 깜빡인다 (loading 은 첫 불러오기에만 true)
    const params = {
      curr_page: currPage,
      per_page: LIST_PAGE_SIZE,
      sort_col: "reg_dtm",
      sort_by: "desc",
    };

    request.get("/admin/sub-admin/list", params, (response) => {
      setLoading(false);
      if (response.messageCode !== 200) {
        toast.error(response.messageString || "부관리자 목록을 불러올 수 없습니다.");
        return;
      }

      setSubAdmins(response.data?.dataList || []);
      setTotalPages(Number(response.data?.tot_page) || 0);
      setTotalCnt(Number(response.data?.totalCnt) || 0);
    }, () => {
      setLoading(false);
      toast.error("부관리자 목록을 불러오는 중 오류가 발생했습니다.");
    });
  }, [currPage]);

  useEffect(() => {
    fetchSubAdmins();
  }, [fetchSubAdmins]);

  const handleDelete = () => {
    if (!deleteTarget?.admin_seq) return;

    request.del(`/admin/sub-admin/${deleteTarget.admin_seq}`, {}, (response) => {
      if (response.messageCode !== 200) {
        toast.error(response.messageString || "부관리자 삭제 중 오류가 발생했습니다.");
        return;
      }

      toast.success("부관리자가 삭제되었습니다.");
      setDeleteTarget(null);
      if (subAdmins.length === 1 && currPage > 1) {
        setCurrPage((prev) => prev - 1);
      } else {
        fetchSubAdmins();
      }
    }, () => {
      toast.error("부관리자 삭제 중 오류가 발생했습니다.");
    });
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">부관리자 계정 관리</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_btn_wrap">
          <button className="adm_com_btn black" onClick={() => navigate("/Setting/Manager/SubAdmin/Write")}>추가</button>
        </div>
        {loading ? null : (
          <table className="adm_com_board_list">
            <colgroup>
              <col width="6%" /><col width="16%" /><col width="14%" /><col /><col width="14%" /><col width="12%" /><col width="12%" />
            </colgroup>
            <thead>
              <tr>
                <th>번호</th>
                <th>아이디</th>
                <th>이름</th>
                <th>이메일</th>
                <th>휴대폰</th>
                <th>등록일</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {subAdmins.length === 0 && (
                <tr>
                  <td colSpan={7}>등록된 부관리자가 없습니다.</td>
                </tr>
              )}
              {subAdmins.map((admin, index) => (
                <tr key={admin.admin_seq}>
                  <td>{totalCnt - ((currPage - 1) * LIST_PAGE_SIZE + index)}</td>
                  <td>{admin.admin_id}</td>
                  <td>{admin.admin_name}</td>
                  <td>{admin.admin_email || "-"}</td>
                  <td>{admin.admin_phone || "-"}</td>
                  <td>{formatDate(admin.reg_dtm)}</td>
                  <td>
                    <button
                      className="adm_com_btn blue line"
                      onClick={() => navigate(`/Setting/Manager/SubAdmin/Write/${admin.admin_seq}`)}
                    >
                      수정
                    </button>
                    <button
                      className="adm_com_btn gray line"
                      onClick={() => setDeleteTarget(admin)}
                    >
                      삭제
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {totalPages > 0 && (
          <Paging currentPage={currPage} totalPages={totalPages} onPageChange={setCurrPage} />
        )}
      </div>
      <Modal
        open={Boolean(deleteTarget)}
        close={() => setDeleteTarget(null)}
        type="confirm"
        popSize="s"
        title="삭제 확인"
        description={`${deleteTarget?.admin_id || ""} 부관리자를 삭제하시겠습니까?`}
      >
        <div className="btn_container">
          <button className="adm_com_btn blue" onClick={handleDelete}>삭제</button>
          <button className="adm_com_btn gray" onClick={() => setDeleteTarget(null)}>취소</button>
        </div>
      </Modal>
      <ToastContainer />
    </main>
  );
};

export default SettingSubAdmin;
